import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4619f906"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my-header" }
const _hoisted_2 = { style: {"font-size":"22px"} }
const _hoisted_3 = { class: "notice-stats-detail" }
const _hoisted_4 = { class: "search-form" }

import { ref, computed, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import { getListData, downloadData } from '@/service/main/system'
import dayjs from 'dayjs'
import { useStore } from '@/store'


export default /*#__PURE__*/_defineComponent({
  __name: 'tablist',
  setup(__props, { expose: __expose }) {

const dialogVisible = ref(false)
const currentRow = ref<any>(null)
const tableData = ref<any[]>([])
const searchForm = ref({
  empName: '',
  deptName: ''
})
const groupOptions = ref<any[]>([])

const store = useStore()

const dialogTitle = computed(() => {
  if (currentRow.value && currentRow.value.name) {
    return currentRow.value.name
  }
  return '通知阅读记录详情'
})

/**
 * 获取状态颜色
 */
const getStatusColor = (status: string) => {
  if (status === '已读') {
    return '#67c23a'
  } else if (status === '未读') {
    return '#f56c6c'
  }
  return '#909399'
}

/**
 * 初始化组别选项（通过接口获取）
 */
const initGroupOptions = async () => {
  try {
    const res = await getListData('/main/resourceAnalysis/getTop13DepartmentListByDeptSort', {})

    if (res && Array.isArray(res)) {
      groupOptions.value = res.map((item: any) => ({
        label: item.name,
        value: item.name
      }))
      console.log('从接口获取组别成功:', groupOptions.value)
    } else {
      console.warn('接口返回的组别数据为空')
      groupOptions.value = []
    }
  } catch (error) {
    console.error('获取组别数据失败:', error)
    ElMessage.error('组别数据加载失败')
    groupOptions.value = []
  }
}

/**
 * 打开弹窗
 */
const open = (row: any) => {
  currentRow.value = row
  dialogVisible.value = true
  searchForm.value = {
    empName: '',
    deptName: ''
  }
  loadData()
}

/**
 * 关闭弹窗
 */
const handleClose = () => {
  dialogVisible.value = false
  tableData.value = []
  currentRow.value = null
  searchForm.value = {
    empName: '',
    deptName: ''
  }
}

/**
 * 加载数据
 */
const loadData = async () => {
  try {
    const params: any = {
      targetDate: currentRow.value?.date
    }

    if (searchForm.value.empName) {
      params.empName = searchForm.value.empName
    }
    if (searchForm.value.deptName) {
      params.deptName = searchForm.value.deptName
    }

    const res = await getListData('/main/notice-stats/getAllEmpNoticeStatsSummary', params)

    if (res && Array.isArray(res)) {
      tableData.value = res
    } else {
      tableData.value = []
    }
  } catch (error) {
    console.error('加载数据失败:', error)
    ElMessage.error('数据加载失败')
  }
}

/**
 * 查询
 */
const handleSearch = () => {
  loadData()
}

/**
 * 重置
 */
const resetSearch = () => {
  searchForm.value = {
    empName: '',
    deptName: ''
  }
  loadData()
}

/**
 * 下载
 */
const handleDownload = async () => {
  try {
    const params: any = {
      targetDate: currentRow.value?.date
    }

    if (searchForm.value.empName) {
      params.empName = searchForm.value.empName
    }
    if (searchForm.value.deptName) {
      params.deptName = searchForm.value.deptName
    }

    // 修改为 GET 请求
    const res = await downloadData('/main/notice-stats/exportAllEmpNoticeStatsSummary', params, 'blob')

    const blob = new Blob([res], {
      type: 'application/octet-stream'
    })
    const down = document.createElement('a')
    down.download = `通知阅读记录_${dayjs().format('YYYY-MM-DD HH:mm:ss')}.xlsx`
    down.style.display = 'none'
    down.href = URL.createObjectURL(blob)
    document.body.appendChild(down)
    down.click()
    URL.revokeObjectURL(down.href)
    document.body.removeChild(down)

    ElMessage.success('下载成功')
  } catch (error) {
    console.error('下载失败:', error)
    ElMessage.error('下载失败，请重试')
  }
}

onMounted(() => {
  initGroupOptions()
})

__expose({
  open
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialogVisible).value = $event)),
    fullscreen: true,
    "show-close": false
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(dialogTitle.value), 1),
        _createVNode(_component_el_button, {
          type: "danger",
          icon: "el-icon-close",
          size: "small",
          onClick: handleClose,
          style: {"position":"absolute","top":"0","right":"10px"}
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 关闭 ")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_form, {
            inline: true,
            model: searchForm.value,
            class: "demo-form-inline"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "业务员姓名：" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: searchForm.value.empName,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchForm.value.empName) = $event)),
                    placeholder: "请输入业务员姓名",
                    clearable: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "组别：" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: searchForm.value.deptName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchForm.value.deptName) = $event)),
                    placeholder: "请选择组别",
                    clearable: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupOptions.value, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: handleSearch
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("查询")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, { onClick: resetSearch }, {
                    default: _withCtx(() => [
                      _createTextVNode("重置")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    type: "success",
                    onClick: handleDownload
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("下载")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _createVNode(_component_el_table, {
          data: tableData.value,
          border: "",
          style: {"width":"100%"},
          "max-height": "600"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "empName",
              label: "姓名",
              width: "100",
              fixed: "left"
            }),
            _createVNode(_component_el_table_column, {
              prop: "deptName",
              label: "组别",
              width: "150",
              fixed: "left"
            }),
            _createVNode(_component_el_table_column, {
              label: "前一日观看直播客户",
              "min-width": "140"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", {
                  style: _normalizeStyle({ color: getStatusColor(scope.row.watchLiveStatus) })
                }, _toDisplayString(scope.row.watchLiveStatus || '无'), 5)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "30天内累计观看大于10天的客户",
              "min-width": "180"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", {
                  style: _normalizeStyle({ color: getStatusColor(scope.row.watchLiveOver10DaysStatus) })
                }, _toDisplayString(scope.row.watchLiveOver10DaysStatus || '无'), 5)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "前一日未回复客户",
              "min-width": "140"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", {
                  style: _normalizeStyle({ color: getStatusColor(scope.row.unrepliedCustomerListStatus) })
                }, _toDisplayString(scope.row.unrepliedCustomerListStatus || '无'), 5)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "前一日观看录播超过3分钟客户",
              "min-width": "180"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", {
                  style: _normalizeStyle({ color: getStatusColor(scope.row.watchRecordOver3MinStatus) })
                }, _toDisplayString(scope.row.watchRecordOver3MinStatus || '无'), 5)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "近一周不允许拉群客户",
              "min-width": "150"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", {
                  style: _normalizeStyle({ color: getStatusColor(scope.row.notAllowGroupStatus) })
                }, _toDisplayString(scope.row.notAllowGroupStatus || '无'), 5)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "新资源承接需联系列表",
              "min-width": "150"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", {
                  style: _normalizeStyle({ color: getStatusColor(scope.row.newResourceContactListStatus) })
                }, _toDisplayString(scope.row.newResourceContactListStatus || '无'), 5)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "本月通话次数和时长统计",
              "min-width": "160"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", {
                  style: _normalizeStyle({ color: getStatusColor(scope.row.callDurationStatsStatus) })
                }, _toDisplayString(scope.row.callDurationStatsStatus || '无'), 5)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "重复资源成交客户",
              "min-width": "140"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", {
                  style: _normalizeStyle({ color: getStatusColor(scope.row.repeatResourceStatus) })
                }, _toDisplayString(scope.row.repeatResourceStatus || '无'), 5)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "直播间定金订单客户信息",
              "min-width": "170"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", {
                  style: _normalizeStyle({ color: getStatusColor(scope.row.depositOrderStatus) })
                }, _toDisplayString(scope.row.depositOrderStatus || '无'), 5)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "敏感词预警",
              "min-width": "120"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", {
                  style: _normalizeStyle({ color: getStatusColor(scope.row.preSalesSensitiveWordsStatus) })
                }, _toDisplayString(scope.row.preSalesSensitiveWordsStatus || '无'), 5)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "电话+直播不达标",
              "min-width": "140"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", {
                  style: _normalizeStyle({ color: getStatusColor(scope.row.callLiveNotMeetStandardStatus) })
                }, _toDisplayString(scope.row.callLiveNotMeetStandardStatus || '无'), 5)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "业绩汇总",
              "min-width": "100"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", {
                  style: _normalizeStyle({ color: getStatusColor(scope.row.performanceSummaryStatus) })
                }, _toDisplayString(scope.row.performanceSummaryStatus || '无'), 5)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "客户索要资料检查数据",
              "min-width": "140"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", {
                  style: _normalizeStyle({ color: getStatusColor(scope.row.postMaterialHasQuestionStatus) })
                }, _toDisplayString(scope.row.postMaterialHasQuestionStatus || '无'), 5)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "新资源五分钟内未发消息",
              "min-width": "140"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", {
                  style: _normalizeStyle({ color: getStatusColor(scope.row.responseWithinRequiredTimeStatus) })
                }, _toDisplayString(scope.row.responseWithinRequiredTimeStatus || '无'), 5)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "资料后是否有问句",
              "min-width": "140"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", {
                  style: _normalizeStyle({ color: getStatusColor(scope.row.hasCustomerRequestStatus) })
                }, _toDisplayString(scope.row.hasCustomerRequestStatus || '无'), 5)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "承接后当天是否发送课程介绍",
              "min-width": "140"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", {
                  style: _normalizeStyle({ color: getStatusColor(scope.row.hasCourseIntroAndLinkStatus) })
                }, _toDisplayString(scope.row.hasCourseIntroAndLinkStatus || '无'), 5)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "承接后当天是否发送课程铺垫",
              "min-width": "140"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", {
                  style: _normalizeStyle({ color: getStatusColor(scope.row.hasCourseForeshadowingStatus) })
                }, _toDisplayString(scope.row.hasCourseForeshadowingStatus || '无'), 5)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "承接后当天是否询问资金量",
              "min-width": "140"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", {
                  style: _normalizeStyle({ color: getStatusColor(scope.row.hasFundAmountInquiryStatus) })
                }, _toDisplayString(scope.row.hasFundAmountInquiryStatus || '无'), 5)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "一小时内是否私聊检查",
              "min-width": "140"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", {
                  style: _normalizeStyle({ color: getStatusColor(scope.row.customerResponseTimeoutStatus) })
                }, _toDisplayString(scope.row.customerResponseTimeoutStatus || '无'), 5)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})